app.factory("selfcheckService", function () {
    return {
        //セルフチェックの解答群
        choiceTypes: [
            { "score": "0", "text": "できていない" },
            { "score": "1", "text": "あまりできていない" },
            { "score": "2", "text": "どちらともいえない" },
            { "score": "3", "text": "まあまあできている" },
            { "score": "4", "text": "できている" },
        ],
        //セルフチェックの問
        questionTypes: [{
            "qid": "1",
            "text": "なるべく腹八分目を心がけている",
            "text2": "なるべく腹八分目を心がける",
            "comment": "腹八分目。昔から言われていたことですが、実際、様々な病気の予防につながること、長寿遺伝子が活性化することがわかっています",
            "score" : {
                "yes" : "4",
                "no"  : "0"
            }
        },
        {
            "qid": "2",
            "text": "3食ほぼ決まった時間に食べる",
            "text2": "3食ほぼ決まった時間に食べるよう心がける",
            "comment": "私たちのからだには「体内時計」と呼ばれる機能があります。快適な生活を送るためにも朝・昼・晩の食事の時間を中心に、生活リズムを整えましょう。",
            "score" : {
                "yes" : "4",
                "no"  : "0"
            }
        },
        {
            "qid": "3",
            "text": "朝食はほぼ毎日食べる",
            "text2": "朝食はほぼ毎日食べることを心がける",
            "comment": "朝食抜きの習慣は生活習慣病のリスクを高めるといわれています。朝は食欲がわかないという人は、起きてすぐに水や牛乳、野菜ジュースを飲んで、胃を目覚めさせるのがおすすめです。",
            "score" : {
                "yes" : "4",
                "no"  : "0"
            }
        },
        {
            "qid": "4",
            "text": "ゆっくりよく噛んで食べる",
            "text2": "ゆっくりよく噛んで食べるよう心がける",
            "comment": "よく噛んで食べると、食事が少量でも食欲が抑えられ、脳内物質の働きとして内臓脂肪の分解を促進するといわれています。",
            "score" : {
                "yes" : "4",
                "no"  : "0"
            }
        },
        {
            "qid": "5",
            "text": "就寝前2時間以内に飲食はしない",
            "text2": "就寝前2時間以内に飲食をしないよう心がける",
            "comment": "夜遅い時間に食事をとると、食事からとったエネルギーが消費されにくく、余分なエネルギーは体脂肪として蓄積されやすくなります。翌朝、食欲がなくて朝食が食べられない原因にもなります。",
            "score" : {
                "yes" : "4",
                "no"  : "0"
            }
        },
        {
            "qid": "6",
            "text": "食事は1人分を盛りきるようにしている",
            "text2": "食事は1人分を盛りきるよう心がける",
            "comment": "腹八分目。昔から言われていたことですが、実際、様々な病気の予防につながること、長寿遺伝子が活性化することがわかっています",
            "score" : {
                "yes" : "4",
                "no"  : "0"
            }
        },
        {
            "qid": "7",
            "text": "ご飯を食べる時の1回量はお茶碗1杯くらい",
            "text2": "ご飯を食べる時の1回量はお茶碗1杯くらいにするよう心がける",
            "comment": "ご飯の1杯(150g）は約240kcal。これまでより毎日1杯減らすと1ヶ月間で脂肪1kg分(約7200kcal）のエネルギーがマイナスになります。",
            "score" : {
                "yes" : "4",
                "no"  : "0"
            }
        },
        {
            "qid": "8",
            "text": "丼もののご飯は少なめに（注文）している",
            "text2": "丼もののご飯は少なめに（注文）するよう心がける",
            "comment": "ご飯の1杯(150g）は約240kcal。これまでより毎日1杯減らすと1ヶ月間で脂肪1kg分(約7200kcal）のエネルギーがマイナスになります。",
            "score" : {
                "yes" : "4",
                "no"  : "0"
            }
        },
        {
            "qid": "9",
            "text": "揚げ物は、1週間に3回以上食べる",
            "text2": "揚げ物は、1週間に2回以内に抑える",
            "comment": "肝臓に負担をかけないためには、食べながら飲むことが大切です。ただし、お酒は食欲を増進させるので、食べ過ぎないように注意が必要です。食事と一緒にゆっくり飲むことで、飲酒後の食欲を抑えましょう。",
            "score" : {
                "yes" : "0",
                "no"  : "4"
            }
        },
        {
            "qid": "10",
            "text": "脂肪の多い肉（バラ肉やベーコンなど）を1週間に3回以上食べる",
            "text2": "脂肪の多い肉（バラ肉やベーコンなど）を1週間に2回以内に抑える",
            "comment": "脂肪を多くとり過ぎると、血液中のコレステロールや中性脂肪が血液中に増え、動脈硬化や高脂血症といった疾患を引き起こしやすくなります。",
            "score" : {
                "yes" : "0",
                "no"  : "4"
            }
        },
        {
            "qid": "11",
            "text": "魚料理を1週間に4回以上食べる",
            "text2": "魚料理を1週間に4回以上食べるよう心がける",
            "comment": "肉類の脂身や鶏肉の皮・ラード・バター・乳脂肪・ココナッツミルクなどには、血中コレステロールを上げる作用のある飽和脂肪酸が多く含まれます。肉は赤身のものや脂身をとり除いて食べましょう。牛乳も低脂肪乳にするとよいでしょう。",
            "score" : {
                "yes" : "4",
                "no"  : "0"
            }
        },
        {
            "qid": "12",
            "text": "納豆、豆腐などの大豆製品や大豆（黒豆、枝豆含む）を毎日食べる",
            "text2": "納豆、豆腐などの大豆製品や大豆（黒豆、枝豆含む）を毎日食べるよう心がける",
            "comment": "魚などに含まれている不飽和脂肪酸には、動脈硬化を予防する働きがあります。",
            "score" : {
                "yes" : "4",
                "no"  : "0"
            }
        },
        {
            "qid": "13",
            "text": "野菜・きのこ類・海藻類のおかずを毎食小鉢1～2品以上食べる",
            "text2": "野菜・きのこ類・海藻類のおかずを毎食小鉢1～2品以上食べるよう心がける",
            "comment": "大豆は、肉や魚のようにたんぱく質が多く、ビタミンやミネラル、食物繊維も豊富です。脂質が少ないので肉や魚を大豆製品に置き換えることで、摂取エネルギーを減らすことができます。",
            "score" : {
                "yes" : "4",
                "no"  : "0"
            }
        },
        {
            "qid": "14",
            "text": "汁物は具だくさん（野菜や海藻、きのこなど）にしている",
            "text2": "汁物は具だくさん（野菜や海藻、きのこなど）にするよう心がける",
            "comment": "野菜やきのこ類、海草類は、低エネルギーでビタミンやミネラル・食物繊維が多く含まれています。ご飯や肉・魚など様々な食品と組み合わせて食べることにより、体の調子を整え、生活習慣病を予防します。",
            "score" : {
                "yes" : "4",
                "no"  : "0"
            }
        },
        {
            "qid": "15",
            "text": "汁物は1日1～２杯程度もしくは飲まない",
            "text2": "汁物は1日1～２杯程度もしくは飲まないよう心がける",
            "comment": "汁物の回数は1-2回がベスト。野菜などで具だくさんにすると、汁の量が少なくても満足できます。野菜に多く含まれるカリウムは、余分なナトリウム（食塩）を体外に排泄するのを手助けしてくれ、高血圧の予防にもなります。",
            "score" : {
                "yes" : "4",
                "no"  : "0"
            }
        },
        {
            "qid": "16",
            "text": "麺類の汁は半分以上残すことが多い",
            "text2": "麺類の汁は半分以上残すよう心がける",
            "comment": "野菜に多く含まれるカリウムは、余分なナトリウム（食塩）を体外に排泄するのを手助けしてくれ、高血圧の予防にもなります。",
            "score" : {
                "yes" : "4",
                "no"  : "0"
            }
        },
        {
            "qid": "17",
            "text": "味付きの食べ物にかけ塩・かけ醤油はしない",
            "text2": "味付きの食べ物にかけ塩・かけ醤油はしないよう心がける",
            "comment": "塩分を過剰にとることにより、高血圧となり動脈硬化や脳血管障害などを誘発する原因につながります。摂取する食塩はより少ないほうが高血圧の予防・改善に効果的なため、塩分のとり方には、注意が必要です。",
            "score" : {
                "yes" : "4",
                "no"  : "0"
            }
        },
        {
            "qid": "18",
            "text": "漬物・佃煮・塩蔵品（すじこやたらこなど）は、少量を1日1回程度もしくはあまり食べない",
            "text2": "漬物・佃煮・塩蔵品（すじこやたらこなど）は、少量を1日1回程度もしくはあまり食べないよう心がける",
            "comment": "料理にしょうゆやソース・ドレッシングなどを使うときには、皿の底に残るほどかけ過ぎないことや、料理に直接にかけず小皿等に調味料をとりわけてつけながら食べるなどの工夫も必要です。",
            "score" : {
                "yes" : "4",
                "no"  : "0"
            }
        },
        {
            "qid": "19",
            "text": "味付けはうす味を心がけている",
            "text2": "味付けはうす味を心がける",
            "comment": "漬物や佃煮、塩蔵品は塩分が豊富な食品。小量を楽しみましょう。味が濃いので、ほかの食材と和えたりして味付けの食材として楽しむのも上手な取り方です。",
            "score" : {
                "yes" : "4",
                "no"  : "0"
            }
        },
        {
            "qid": "20",
            "text": "お菓子などの間食は1日に2回以下",
            "text2": "お菓子などの間食は1日に2回以下にするよう心がける",
            "comment": "しょうがやネギ、にんにくなどの香味野菜やレモンやゆず、かぼすなどの柑橘類を使うと薄味でもおいしく料理がいただけます。薄味は慣れもあるので、心がけが大事です。",
            "score" : {
                "yes" : "4",
                "no"  : "0"
            }
        },
        {
            "qid": "21",
            "text": "砂糖入り飲料（ジュース類・加糖コーヒー・炭酸など）は1日1杯以下",
            "text2": "砂糖入り飲料（ジュース類・加糖コーヒー・炭酸など）は1日1杯以下に抑える",
            "comment": "一般的には1日に200kcal程度の間食が適量です。",
            "score" : {
                "yes" : "4",
                "no"  : "0"
            }
        },
        {
            "qid" : "00",
            "text": "以降の問いは飲酒の習慣がある方のみ回答をしていただきます。飲酒の習慣がありますか？",
            "text2": "",
            "comment": "",
            "score" : {
                "yes" : "0",
                "no"  : "16"
            }
        },
        {
            "qid": "22",
            "text": "お酒を飲まない日（休肝日）が1週間に2日以上ある",
            "text2": "お酒を飲まない日（休肝日）が1週間に1日以下に抑える",
            "comment": "たとえば缶コーヒー1本（185g）のエネルギーは60-80kcal。ご飯１/３杯分です",
            "score" : {
                "yes" : "4",
                "no"  : "0"
            }
        },
        {
            "qid": "23",
            "text": "お酒の1回量は、ビール500ml（日本酒1合、焼酎100ml、ワイン200ml、ウィスキー60ml、チューハイ1缶）以下",
            "text2": "お酒の1回量をビール500ml（日本酒1合、焼酎100ml、ワイン200ml、ウィスキー60ml、チューハイ1缶）以下に抑える",
            "comment": "習慣的な飲酒を継続しているとアルコールは依存性薬物のため耐性が発生し、徐々に飲酒量が増加する危険性があります。",
            "score" : {
                "yes" : "4",
                "no"  : "0"
            }
        },
        {
            "qid": "24",
            "text": "酒のつまみは低カロリー食品（野菜スティックなど）などが多い",
            "text2": "酒のつまみは低カロリー食品（野菜スティックなど）にすることを心がける",
            "comment": "節度ある適度な飲酒は1日平均純アルコールで20グラム(日本酒1合)程度の飲酒といわれています。その他、ビール中ビン1本、チュウハイ（7%）350mL缶1本、ウィスキーダブル1杯などが相当します。",
            "score" : {
                "yes" : "4",
                "no"  : "0"
            }
        },
        {
            "qid": "25",
            "text": "飲酒後にラーメン、お茶漬けなどをよく食べる",
            "text2": "飲酒後にラーメン、お茶漬けなどを食べないよう心がける",
            "comment": "肝臓に負担をかけないためには、食べながら飲むことが大切です。ただし、お酒は食欲を増進させるので、食べ過ぎないように注意が必要です。飲酒は適度な量にとどめ、良質のたんぱく質がとれる主菜やビタミン、ミネラルが豊富な副菜を上手に選んで楽しく飲みましょう。",
            "score" : {
                "yes" : "0",
                "no"  : "4"
            }
        }],

        //評価コメント
        gradeComment: [
            { "minScore": 0, "maxScore": 25, "text": "からだにe食生活で実践できていない行動を確認できましたね。行動を意識するだけでもe食生活に近づきます。まずは「できるかも」と思える行動からチャレンジしてみましょう。私たちが応援します！" },
            { "minScore": 25, "maxScore": 50, "text": "からだにe食生活で実践できていない行動を確認できましたね。意識するだけでもe食生活に近づきます。まずは「できるかも」と思える行動からチャレンジしてみましょう。私たちが応援します！" },
            { "minScore": 50, "maxScore": 75, "text": "からだにe食生活で実践できている行動も多いですね！行動を意識するだけでもe食生活に近づきます。「まあできている・できている」と言える行動をさらに増やしていきましょう。私たちが応援します！" },
            { "minScore": 75, "maxScore": 100, "text": "からだにe食生活をしっかり実践していますね！ぜひこれからも継続してくださいね。" }
        ],

        //おすすめ行動と食生活チェック問番号の対応表
        reco_qid_table: [
            { "recoid": "reco01", "text": "3食を腹八分目におさえる", "qidcsv": "1,6" },
            { "recoid": "reco02", "text": "3食　決まった時間に食べる", "qidcsv": "2" },
            { "recoid": "reco03", "text": "朝食を食べる", "qidcsv": "3" },
            { "recoid": "reco04", "text": "3食　1口20回以上を目標に咀嚼する", "qidcsv": "4" },
            { "recoid": "reco05", "text": "寝る２時間前に飲食をしない", "qidcsv": "5" },
            { "recoid": "reco06", "text": "ご飯の量を普通盛り1杯にする", "qidcsv": "7,8" },
            { "recoid": "reco07", "text": "飲酒後にラーメン、お茶漬けなどを食べない", "qidcsv": "9" },
            { "recoid": "reco08", "text": "揚げ物料理を控える", "qidcsv": "10" },
            { "recoid": "reco09", "text": "肉料理は脂肪の少ない肉を選ぶ", "qidcsv": "11" },
            { "recoid": "reco10", "text": "1日に1品は魚料理を取り入れる", "qidcsv": "12" },
            { "recoid": "reco11", "text": "1日に１～２品は大豆製品を取り入れる", "qidcsv": "13,14" },
            { "recoid": "reco12", "text": "汁物を具だくさんで1日1－２杯にする", "qidcsv": "15,16,17" },
            { "recoid": "reco13", "text": "味付きの食物にかけ塩・かけしょうゆをしない", "qidcsv": "18" },
            { "recoid": "reco14", "text": "漬物・佃煮・塩蔵品は避ける", "qidcsv": "19" },
            { "recoid": "reco15", "text": "味つけは薄味にする", "qidcsv": "20" },
            { "recoid": "reco16", "text": "間食を1日1回程度にする", "qidcsv": "21" },
            { "recoid": "reco17", "text": "ジュースや缶コーヒーをお茶やコーヒーにかえる。", "qidcsv": "22" },
            { "recoid": "reco18", "text": "休肝日を週に2日以上つくる", "qidcsv": "23" },
            { "recoid": "reco19", "text": "お酒の量を1日1合以内にする", "qidcsv": "24" },
            { "recoid": "reco20", "text": "お酒のつまみは低カロリーのものにする", "qidcsv": "25" },
        ],

        //おすすめ行動情報取得
        getRecommendinfo: function (qid) {
            var reco;
            for (var i = 0; i < this.reco_qid_table.length; i++) {
                if (this.reco_qid_table[i].qidcsv.split(",").indexOf(qid) != -1) {
                    reco = {
                        "recoid": this.reco_qid_table[i].recoid,
                        "text": this.reco_qid_table[i].text,
                        "qidcsv": this.reco_qid_table[i].qidcsv
                    }
                    break;
                }
            }
            return reco;
        },

        //getCheckboxInfoで重複排除目的で使用
        include_recoid: function (checkboxList, reco_id) {
            var rs = false;
            for (var i = 0; i < checkboxList.length; i++) {
                if (checkboxList[i].recoid == reco_id) {
                    rs = true;
                    break;
                }
            }
            return rs;
        },

        //設定済み目標と達成済み目標情報を表示するためのcheckbox情報
        getCheckboxInfo: function (configuredList, achievedList) {
            var checkboxList = new Array();
            for (var i = 0; i < configuredList.length; i++) {
                var rinfo = this.getRecommendinfo(configuredList[i]);
                if (!this.include_recoid(checkboxList, rinfo.recoid)) {
                    var status = false;
                    for (var j = 0; j < achievedList.length; j++) {
                        if (rinfo.qidcsv.split(",").indexOf(achievedList[j]) != -1) {
                            status = true;
                        }
                    }
                    var infotmp = {
                        "text": rinfo.text,
                        "recoid": rinfo.recoid,
                        "value": rinfo.qidcsv,
                        "status": status
                    }
                    checkboxList.push(infotmp);
                }
            }
            return checkboxList;
        },

        //checkboxの値リスト
        getValueList: function (checkboxList) {
            var valuelist = new Array(checkboxList.length);
            for (var i = 0; i < checkboxList.length; i++) {
                valuelist[i] = "0";
                if (checkboxList[i].status) {
                    valuelist[i] = checkboxList[i].value;
                }
            }
            return valuelist;
        }
    }
});